import FrontStickySeeOnMap from "@/Components/Front/Blocks/FrontStickySeeOnMap";
import FrontViewOnMap from "@/Components/Front/Blocks/FrontViewOnMap";
import FrontWarehousesLoop from "@/Components/Front/Blocks/FrontWarehousesLoop";
import FrontStandardSearcher from "@/Components/Front/Forms/FrontStandardSearcher";
import FrontPagination from "@/Components/Front/FrontPagination";
import FrontText from "@/Components/Front/FrontText";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import capitalizeFirstLetter from "@/Helpers/capitalizeFirstLetter";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { useEffect, useRef, useState } from "react";
import { geocode, RequestType, setDefaults } from "react-geocode";
import { useTranslation } from "react-i18next";

const WarehousesDashboard = ({ viewWarehouses, noindex, province, city, warehouseCount, warehouses, cities, regions, searchRegion, keyword = '', cityDesc, queryParams = {} }) => {
    const { t, i18n } = useTranslation();
    const warehouseLoopRef = useRef(null);

    const checkIfDescription = () => {
        if (province) {
            if (i18n.resolvedLanguage === 'pl' && province.description) {
                return true;
            }
            if (i18n.resolvedLanguage === 'en' && province.description_en) {
                return true;
            }
        }
        return false
    }
    let seoTitle = '';

    if (i18n.resolvedLanguage === 'pl') {
        if (province != null) {
            seoTitle = capitalizeFirstLetter(province.name);
        } else if (city == null) {
            seoTitle = keyword;
        } else {
            seoTitle = capitalizeFirstLetter(city.name);
        }
    } else {
        if (province != null) {
            seoTitle = capitalizeFirstLetter(province.name_en);
        } else if (city == null) {
            seoTitle = keyword;
        } else {
            seoTitle = capitalizeFirstLetter(city.name);
        }
    }

    const seo = {
        title: t('warehouses.titleSingleResults') + seoTitle + t('warehouses.titleSingleResultsEnd')

    }

    let breadcrumbsArray = [];

    if (!province && city) {
        let breadcrumbsProvince = viewWarehouses.data[0].get_region;
        breadcrumbsArray = [
            { title: i18n.resolvedLanguage === 'pl' ? capitalizeFirstLetter(breadcrumbsProvince.name) : capitalizeFirstLetter(breadcrumbsProvince.name_en), current: false, href: resolveLocaleRoute('front.warehouses', { searchRegion: i18n.resolvedLanguage === 'pl' ? breadcrumbsProvince.slug : breadcrumbsProvince.slug_en }, i18n.resolvedLanguage) },
            { title: city.name, current: true },
        ]
    } else {
        breadcrumbsArray = [
            { title: seoTitle, current: true },
        ]
    }

    const isServer = typeof document === 'undefined'

    const [h1ElementDesc, setH1ElementDesc] = useState('');
    const [restOfHtmlDesc, setRestOfHtmlDesc] = useState('');
    
    useEffect(() => {
        if(!isServer){
            const tempElement = document.createElement('div');
            tempElement.innerHTML = i18n.resolvedLanguage == 'pl' ? province?.description : province?.description_en;

            setH1ElementDesc(tempElement.querySelector('h1'));

            if (tempElement.querySelector('h1') != null) {
                setRestOfHtmlDesc(tempElement.innerHTML.replace(tempElement.querySelector('h1').outerHTML, ''));
            }
        }

        if(!isServer && warehouseLoopRef.current && warehouseCount){
            window.scrollTo(0, warehouseLoopRef.current.offsetTop - 150); 
        }
    }, [])

    /* =================== [Check if results - Get nearest City] =================== */
    const [nearestCity, setNearestCity] = useState({});
    
    if (!warehouseCount) {
        useEffect(() => {
            setDefaults({
                key: import.meta.env.VITE_GOOGLE_MAP_API_KEY, // Your API key here.
                language: "pl", // Default language for responses.
                region: "pl", // Default region for responses.
              });
              geocode(RequestType.ADDRESS, keyword)
                .then(({ results }) => {
                  const { city, country } = results[0].address_components.reduce(
                    (acc, component) => {
                        if (component.types.includes("locality"))
                            acc.city = component.long_name;
                        else if (component.types.includes("country"))
                            acc.country = component.long_name;
                        return acc;
                    },
                    {}
                  );
                  const { lat, lng } = results[0].geometry.location;
    
                  if (country === 'Polska') {
                    setNearestCity({city: city, lat: lat, lng: lng});
                  }
                })
                .catch();
        }, [])
    }

    const isFirstListingPage = () => {
        const params = route().params;
        if (!params.page || params.page === '1') {
            return true
        }

        return false
    }
    
    let choosenMetaDesc = i18n.resolvedLanguage == 'pl' ? cityDesc?.meta_desc : cityDesc?.meta_desc_en;

    if(choosenMetaDesc == null){
        choosenMetaDesc = i18n.resolvedLanguage == 'pl' ? `Szukasz magazynu w ${seoTitle}? Znajdź idealną halę na wynajem wśród naszej szerokiej oferty magazynów na wynajem i skontaktuj się już teraz.` : `Looking for a warehouse in ${seoTitle}? Find the perfect warehouse for rent among our wide range of warehouses for rent and get in touch now.`
    }

    seo.description = choosenMetaDesc

    return (
        <FrontLayout
            breadcrumbs={breadcrumbsArray}
        >
            <FrontSeoMetaTags seo={seo} />
            <Container>
                <Row>
                    <Column>
                        <FrontText
                            textSize="28/32"
                            className="text-center text-heading-blue font-bold lg:my-10 md:my-5"
                        >
                            
                            {(Object.keys(nearestCity).length == 0 && !warehouseCount) &&
                                <p>{t('warehouses.headingNearestResultsPartFirst') + seoTitle + '"'}</p>
                            }
                            {nearestCity.city &&
                                <p> {t('warehouses.headingNearestResultsPartFirst') + seoTitle + t('warehouses.headingNearestResultsPartSecond')} </p>
                            }
                            {(Object.keys(nearestCity).length == 0 && warehouseCount > 0) &&
                                <p>{t("warehouses.heading")} {seoTitle}</p>
                            }
                            
                        </FrontText>
                    </Column>
                </Row>
            </Container>

            <FrontStandardSearcher
                countWarehouses={warehouseCount}
                cities={cities}
                warehouses={warehouses}
                regions={regions}
                filterRoute={'front.warehouses'}
                currentProvince={province}
                currentCity={city ? city.slug : null}
                searchRegion={searchRegion ?? keyword}
                queryParams={queryParams}
            />

            <section id="map">
                {city !== null || province !== null ?
                    <FrontViewOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: searchRegion }, i18n.resolvedLanguage)} />
                    :
                    nearestCity.city 
                    ?
                        <FrontViewOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: keyword, coordinates: nearestCity }, i18n.resolvedLanguage)} />
                    :
                        <FrontViewOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: keyword }, i18n.resolvedLanguage)} />
                }
            </section>
            {h1ElementDesc?.innerHTML != null &&
                <Container>
                    <Row>
                        <Column>
                            <FrontText textSize={`38/46`} className="my-5 warehouses-desc">
                                <h1>{h1ElementDesc?.innerHTML}</h1>
                            </FrontText>
                        </Column>
                    </Row>
                </Container>
            }

            {cityDesc != null &&
                <Container>
                    <Row>
                        <Column>
                            <FrontText textSize={`38/46`} className="my-5 warehouses-desc">
                                <h1>{i18n.resolvedLanguage == 'pl' ? cityDesc.h1 : cityDesc.h1_en}</h1>
                            </FrontText>
                        </Column>
                    </Row>
                </Container>
            }
            <section id="warehouses-loop" className="lg:mt-20 mt-15 relative" ref={warehouseLoopRef}>
                {city !== null || province !== null ?
                    <FrontStickySeeOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: searchRegion }, i18n.resolvedLanguage)} />
                    :

                    nearestCity.city 
                    ?
                        <FrontStickySeeOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: keyword, coordinates: nearestCity }, i18n.resolvedLanguage)} /> 
                    :
                        <FrontStickySeeOnMap link={resolveLocaleRoute('front.warehouses.map', { searchRegion: keyword }, i18n.resolvedLanguage)} />
                }
                <FrontWarehousesLoop warehouses={viewWarehouses.data} />
            </section>

            {viewWarehouses.links.length > 3 &&
                <FrontPagination links={viewWarehouses.links} />
            }
            
            {viewWarehouses.links.length == 3 &&
                <div className="lg:my-20 md:my-16 my-5"/>
            }
            
            {(checkIfDescription() && isFirstListingPage()) && (
                <section id="about-warehouse" className="mb-20">
                    <div className="warehouses-desc">
                        <Container>
                            <Row>
                                <Column>
                                    <div className="styled-links" dangerouslySetInnerHTML={{ __html: restOfHtmlDesc }} />
                                </Column>
                            </Row>
                        </Container>
                    </div>
                </section>
            )}
            
            {cityDesc != null && isFirstListingPage() &&
                <section id="about-warehouse" className="mb-20">
                    <div className="warehouses-desc">
                        <Container>
                            <Row>
                                <Column>
                                    <div className="styled-links" dangerouslySetInnerHTML={{ __html: i18n.resolvedLanguage == 'pl' ? cityDesc.desc : cityDesc.desc_en }} />
                                </Column>
                            </Row>
                        </Container>
                    </div>
                </section>
            }
        </FrontLayout>
    );
};

export default WarehousesDashboard;
